export const cameraView06DeckFlexiteekImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 06 - Deck Flexiteek',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    Boom: 1,
    MastAndBoom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView06DeckFlexiteek.js